import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntite } from '.';
import { Courriel } from './courriel.entity';

@Entity('document_activite')
export class DocumentActivite implements BaseEntite {
    static key = 'document-activite';

    @PrimaryGeneratedColumn()
    id: number;

    @Column({ nullable: true })
    name: string;

    @Column({ name: 'url', nullable: true })
    url: string; // Url vers document à télécharger ou générer

    @Column()
    fk_id_courriel: number;

    @ManyToOne(() => Courriel)
    @JoinColumn({ name: 'fk_id_courriel', referencedColumnName: 'id' })
    courriel: Courriel;

    // TODO: à ignorer pour le moment, à remettre après
    // @Column()
    // fk_id_etape: number;

    // @ManyToOne(() => Etape)
    // @JoinColumn({ name: 'fk_id_etape', referencedColumnName: 'id' })
    // etape: Etape;
}
